import {IconButton} from 'platform/components';
import {Heading, HStack} from 'platform/foundation';
import styled, {css} from 'styled-components';

import {ReactNode} from 'react';

interface ActivitySidebarItemV2Props {
  title: string;
  onClose: () => void;
  children: ReactNode;
  disablePadding?: boolean;
}

export function ActivitySidebarItemV2(props: ActivitySidebarItemV2Props) {
  return (
    <ActivityBoxV2>
      <Header data-testid="activity-sidebar-item-header">
        <HStack spacing={4} justify="space-between" align="center">
          <Heading size={4}>{props.title}</Heading>
          <IconButton icon="navigation/close" onClick={props.onClose} />
        </HStack>
      </Header>
      <ContentArea $disablePadding={props.disablePadding}>{props.children}</ContentArea>
    </ActivityBoxV2>
  );
}

const ActivityBoxV2 = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

const Header = styled.div`
  flex-shrink: 0;
  padding: ${({theme}) => theme.getSize(4)};
  border-bottom: 1px solid ${({theme}) => theme.colors.general.separator};
`;

interface ContentAreaProps {
  $disablePadding?: boolean;
}

const ContentArea = styled.div<ContentAreaProps>`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  ${({theme, $disablePadding}) =>
    !$disablePadding &&
    css`
      padding: ${theme.getSize(4)};
    `}
`;
